<script lang="ts">
  import {createEventDispatcher} from 'svelte';
  import editorInstance from '../../lib/editor/editor';
  import {createImageElement} from '../../lib/editor/helpers';

  export let imageUrl: string;

  const dispatch = createEventDispatcher();
</script>

<div class=" cursor-pointer overflow-hidden rounded-md" on:click={() => dispatch('click')}>
  <img src={imageUrl} alt="pixabay" />
</div>
